import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useNavigate } from "react-router-dom"
import { Dropdown, Modal } from 'react-bootstrap'
import Select from "react-select"

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'

import { httpOk, GET, } from 'helpers/api'
import { findKeyFromArrayByValue, formatDate, formatMoney, returnSign } from 'helpers/helpers'
import useDidMountEffect from "pages/parts/useDidMountEffect"
import Rightbar from "../cheques/Rightbar"

function Balance({ warehouse = null, titleKey = 'balance2' }) {
	const { t } = useTranslation()
	const navigate = useNavigate()
	/* OMBORCHIGA PUL KO'RSATILMAYDI (2026-08-26, egasining talabi):
	   faqat nom / tur / ombor / qoldiq. Backend ham maydonlarni o'chirib
	   beradi (ReportController::balance) — bu yerdagisi faqat ustunni
	   jadvaldan olib tashlaydi. */
	const isWarehouse = localStorage.getItem('role') === 'ROLE_WAREHOUSE'

	const [warehouses, setWarehouses] = useState([])
	const [productTypes, setProductTypes] = useState([])
	const [data, setData] = useState([])

	const [showModal, setShowModal] = useState({ show: false, data: {} })
	const [showRightBar, setShowRightBar] = useState(false)
	const [cheque, setCheque] = useState({})

	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({})
	const [pagination, setPagination] = useState({
		url: `/report-balance`,
		response: null
	})
	const [historyPagination, setHistoryPagination] = useState({
		url: `/report-balance-history`,
		response: null
	})

	async function searchWithFilter() {
		var filterUrl = `/report-balance`
		var urlParams = ""
		checkFilter()

		if (filterData.search)
			urlParams += returnSign(urlParams) + 'search=' + filterData.search
		if (filterData.page)
			urlParams += returnSign(urlParams) + 'page=' + filterData.page
		if (filterData.size)
			urlParams += returnSign(urlParams) + 'size=' + filterData.size
		if (filterData.wms_id)
			urlParams += returnSign(urlParams) + 'wms_id=' + filterData.wms_id
		if (filterData.product_type_id)
			urlParams += returnSign(urlParams) + 'product_type_id=' + filterData.product_type_id
		// Ombor bo'limi (rolls/products/finished) — backend biznes mantiqi bo'yicha filtrlaydi
		if (warehouse)
			urlParams += returnSign(urlParams) + 'warehouse=' + warehouse

		if (`/report-balance${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
			if (dropdownIsOpen) setDropdownIsOpen(false)
		}
	}

	async function getBalanceHistory(item) {
		var filterUrl = `/report-balance-history`
		var urlParams = ""

		if (item.product_id)
			urlParams += returnSign(urlParams) + 'product_id=' + item.product_id
		if (filterData.search)
			urlParams += returnSign(urlParams) + 'search=' + filterData.search
		if (historyPagination.page)
			urlParams += returnSign(urlParams) + 'page=' + historyPagination.page
		if (historyPagination.size)
			urlParams += returnSign(urlParams) + 'size=' + historyPagination.size

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setShowModal({ show: true, data: response.data, item })
			setHistoryPagination({ ...historyPagination, 'url': filterUrl, 'response': response.data })
		}
	}

	async function toggleModal(bool, item) {
		if (bool) {
			setHistoryPagination({ url: `/report-balance-history`, response: null, page: '', size: '' })
			await getBalanceHistory(item);
		} else {
			setShowModal({ show: false, data: {}, item: null })
			setHistoryPagination({ url: `/report-balance-history`, response: null, page: '', size: '' })
		}
	}

	async function redirect(item) {
		if (item.movement_type_id === 1) {
			const response = await GET(`/cheques/${item.entity_id}`, {}, { loader: true })
			if (httpOk(response)) {
				setCheque(response.data)
				setShowRightBar(true)
			}
		}
		// Omborchida hujjat preview routelari yo'q — bosish chalg'itmasin
		if (isWarehouse) return
		if (item.movement_type_id === 2) {
			navigate(`/documents-in/preview/${item.entity_id}`)
		}
		if (item.movement_type_id === 3 || item.movement_type_id === 4) {
			navigate(`/documents-preparation/preview/${item.entity_id}`)
		}
		if (item.movement_type_id === 5) {
			navigate(`/write-off/preview/${item.entity_id}`)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	function resetFilter() {
		setFilterData({
			search: '',
			wms_id: '',
			product_type_id: '',
		})

		searchWithFilter();
	}

	function checkFilter() {
		if (
			filterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	function getMovementQuantityClass(item) {
		if (item.movement_name === t('return')) {
			return 'text-warning'
		}

		return item.movement_transaction_type === 'plus' ? 'text-success' : 'text-danger'
	}

	async function paginate(page, size) {
		setFilterData({ ...filterData, 'page': page, 'size': size })
	}

	async function paginateHistory(page, size) {
		setHistoryPagination({ ...historyPagination, 'page': page, 'size': size })
	}

	async function getWms() {
		const response = await GET('/helper/wms')
		if (httpOk(response)) {
			setWarehouses(response.data)
			// Boshlang'ich ombor faqat birinchi yuklashda o'rnatiladi (filtrni qayta tiklamaydi)
			if (response.data[0]) setFilterData(prev => ({ ...prev, wms_id: response.data[0].id }))
		}
	}

	async function getProductTypes() {
		const response = await GET('/helper/products-types')
		if (httpOk(response)) setProductTypes(response.data)
	}

	// Bir marta: ombor va turlarni yuklash (ilgari har qidiruv/sahifada qayta yuklanib, wms_id ni tiklardi)
	useEffect(() => {
		getWms()
		getProductTypes()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	// Qidiruv, sahifalash yoki ombor yuklanganda qayta qidirish
	useDidMountEffect(() => {
		searchWithFilter(false)
	}, [warehouses, filterData.search, filterData.page, filterData.size]) // eslint-disable-line react-hooks/exhaustive-deps

	// Ombor bo'limi almashganda (Rulon->Produkt->Tayyor) eski ma'lumot qolmasin — qayta yuklash
	useDidMountEffect(() => {
		searchWithFilter(false)
	}, [titleKey]) // eslint-disable-line react-hooks/exhaustive-deps

	useDidMountEffect(() => {
		if (showModal.show && showModal.item) {
			getBalanceHistory(showModal.item)
		}
	}, [historyPagination.page, historyPagination.size]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header">
				<h4 className="vertical-center h-100">
					{t(titleKey)} [{data?.total ?? 0}]
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex gap-2">
							<FilterSearch
								filterData={filterData}
								setFilterData={setFilterData}>
							</FilterSearch>

							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('warehouses')}</label>
												<Select
													isClearable
													options={warehouses}
													value={warehouses.find(option => option.id === filterData.wms_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'wms_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											{!warehouse &&
												<div className="form-group col-md-6">
													<label>{t('type')}</label>
													<Select
														isClearable
														options={productTypes}
														value={productTypes.find(option => option.id === filterData.product_type_id) || ''}
														onChange={(option) => setFilterData({ ...filterData, 'product_type_id': option ? option.id : null })}
														placeholder=""
														noOptionsMessage={() => t('list_empty')}
														getOptionLabel={(option) => option.name}
														getOptionValue={(option) => option.id}
													/>
												</div>
											}
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end">
													<button className="btn btn-secondary me-2" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
													<button className="btn btn-primary" onClick={() => searchWithFilter()}>{t('apply')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
								{filterData.wms_id &&
									<span className="me-2">
										<b>{t('warehouse')}: </b>
										{findKeyFromArrayByValue(warehouses, 'id', filterData.wms_id, 'name')}
									</span>
								}
								{filterData.product_type_id &&
									<span className="me-2">
										<b>{t('type')}: </b>
										{findKeyFromArrayByValue(productTypes, 'id', filterData.product_type_id, 'name')}
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>
									{t('reset')}
								</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': warehouse === 'finished' ? '28%' : '40%' }}>{t('product_name')}</th>
									<th style={{ 'width': '15%' }}>{t('type')}</th>
									<th style={{ 'width': '12%' }}>{t('warehouse')}</th>
									{warehouse === 'finished' &&
										<th style={{ 'width': '22%' }}>{t('roll')}</th>
									}
									<th style={{ 'width': '10%' }} className="text-end">{t('balance2')}</th>
									{warehouse === 'finished'
										? <>
											<th style={{ 'width': '7%' }}>{t('unit')}</th>
											{!isWarehouse &&
												<th style={{ 'width': '11%' }} className="text-end">{t('sale_price')}</th>
											}
											<th style={{ 'width': '12%' }} className="text-center">{t('created')}</th>
										</>
										: (!isWarehouse &&
											<th style={{ 'width': '10%' }} className="text-end">{t('amount')}</th>
										)
									}
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr className="tr-middle" key={index}>
										<td className="text-center">
											{item.row_number}
										</td>
										<td className="text-primary cursor" onClick={() => toggleModal(true, item)}>
											{item.product_name}
										</td>
										<td>{item.product_type_name}</td>
										<td>{item.wms_name}</td>
										{warehouse === 'finished' &&
											<td>{item.roll_name}</td>
										}
										<td className="text-end">{formatMoney(item.total_balance, 2)}</td>
										{warehouse === 'finished'
											? <>
												<td>{item.unit_name}</td>
												{!isWarehouse &&
													<td className="text-end">{formatMoney(item.sale_price)}</td>
												}
												<td className="text-center">{formatDate(item.created_at)}</td>
											</>
											: (!isWarehouse &&
												<td className="text-end">{formatMoney(item.total_amount)}</td>
											)
										}
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div>

			<Modal show={showModal.show} animation={false} centered dialogClassName="update-modal-width"
				onHide={() => toggleModal(false)} size="xl">
				<Modal.Header closeButton>
					<Modal.Title>
						{t('balance2')} [{showModal.data.total}]
					</Modal.Title>
				</Modal.Header>

				<Modal.Body>


					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '20%' }}>{t('product_name')}</th>
									<th style={{ 'width': '10%' }}>{t('id')}</th>
									<th style={{ 'width': '10%' }}>{t('type')}</th>
									<th style={{ 'width': '10%' }}>{t('warehouse')}</th>
									<th style={{ 'width': '10%' }}>{t('movement')}</th>
									<th style={{ 'minWidth': '70px' }} className="text-end">{t('quantity')}</th>
									<th style={{ 'minWidth': '70px' }} className="text-end">{t('balance2')}</th>
									{!isWarehouse && <>
										<th style={{ 'minWidth': '80px' }} className="text-end">{t('price')}</th>
										<th style={{ 'minWidth': '100px' }} className="text-end">{t('amount')}</th>
									</>}
									<th style={{ 'minWidth': '120px' }} className="text-center">{t('date')}</th>
								</tr>
							</thead>
							<tbody>
								{showModal?.data?.data?.map((item, index) => (
									<tr className="tr-middle" key={index}>
										<td className="text-center">{item.row_number}</td>
										<td className="text-primary cursor" onClick={() => redirect(item)}>{item.product_name}</td>
										<td>{item.element_id}</td>
										<td>{item.product_type_name}</td>
										<td>{item.wms_name}</td>
										<td>{item.movement_name}</td>
										<td className={`text-end ${getMovementQuantityClass(item)}`}>
											{formatMoney(item.quantity, 2)}
										</td>
										<td className="text-end">
											{formatMoney(item.balance, 2)}
										</td>
										{!isWarehouse && <>
											<td className="text-end">{formatMoney(item.cost_price)}</td>
											<td className="text-end">{formatMoney(item.total_amount)}</td>
										</>}
										<td className="text-center">{formatDate(item.created_at, 'dd.MM.yyyy HH:mm')}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{historyPagination.response &&
						<FilterPagination
							pagination={historyPagination}
							paginate={paginateHistory}>
						</FilterPagination>
					}
				</Modal.Body>
			</Modal>

			<Rightbar
				showRightBar={showRightBar}
				setShowRightBar={setShowRightBar}
				selectedItem={cheque}>
			</Rightbar>
		</>
	)
}

export default Balance
